import { Dialog } from "primereact/dialog";
import TabHeader from "../common/TabHeader";
import FileInput from "../common/FileInput";
import { FloatLabel } from "primereact/floatlabel";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { useAppContext } from "../../providers/ProviderAppContainer";
import { useCallback, useState } from "react";
import { Dropdown } from "primereact/dropdown";
import { useSelector } from "react-redux";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Button } from "primereact/button";
import { InputNumber } from "primereact/inputnumber";
import HasRequiredAuthority from "../dependencies/HasRequiredAuthority";
import { AUTHORITIES } from "../../constants";
import { TEXT_NORMAL, TEXT_TITLE } from "../../style";
import { Divider } from "primereact/divider";

export default function DialogAddInquiryWithUser({ visible, closeDialog, onSuccess }) {
    const { requestAPI, showToast } = useAppContext();

    const { branches = [] } = useSelector((state) => state.stateTemplateConfig?.global);
    const { courses = [] } = useSelector((state) => state.stateTemplateConfig?.global);

    const [form, setForm] = useState();
    const [loading, setLoading] = useState();

    const submit = useCallback(() => {
        requestAPI({
            requestPath: `inquiries/with-user`,
            requestMethod: "POST",
            requestPostBody: form,
            setLoading: setLoading,
            onRequestFailure: () => showToast({ severity: "error", summary: "Failed", detail: "Failed To Add Inquiry !", life: 2000 }),
            onResponseReceieved: (inquiry, responseCode) => {
                if (inquiry && responseCode === 201) {
                    showToast({
                        severity: "success",
                        summary: "Added",
                        detail: inquiry.user_created ? "User and inquiry created" : "Inquiry added to existing user",
                        life: 1500,
                    });
                    setForm();
                    closeDialog();
                    onSuccess?.();
                } else {
                    showToast({
                        severity: "error",
                        summary: "Failed",
                        detail: inquiry?.error || "Failed To Add Inquiry !",
                        life: 2000,
                    });
                }
            },
        });
    }, [closeDialog, form, onSuccess, requestAPI, showToast]);

    return (
        <Dialog
            pt={{
                headertitle: { className: TEXT_TITLE },
                content: { className: "overflow-y-scroll" },
            }}
            header="Add New Inquiry"
            visible={visible}
            className="w-11"
            onHide={closeDialog}
        >
            <TabHeader
                className="pt-3"
                title="User + Inquiry"
                highlights={[
                    "Phone is required — existing users are matched by phone",
                    "Email and note are optional",
                    "Otherwise a new user and inquiry are created",
                ]}
            />

            <FileInput
                className={"mt-3"}
                label="User Image"
                type="image"
                cdn_url={form?.image}
                setCDNUrl={(cdn_url) => setForm((prev) => ({ ...prev, image: cdn_url }))}
                disabled={loading}
                source_accessible={false}
            />
            <FloatLabel className="mt-4">
                <InputText
                    value={form?.full_name}
                    id="fullname"
                    className="w-full"
                    onChange={(e) => setForm((prev) => ({ ...prev, full_name: e.target.value }))}
                    disabled={loading}
                />
                <label htmlFor="fullname">Full Name</label>
            </FloatLabel>
            <FloatLabel className="mt-4">
                <InputText
                    value={form?.email}
                    id="email"
                    className="w-full"
                    onChange={(e) => setForm((prev) => ({ ...prev, email: e.target.value }))}
                    disabled={loading}
                />
                <label htmlFor="email">Email</label>
            </FloatLabel>
            <FloatLabel className="mt-4">
                <InputNumber
                    useGrouping={false}
                    className="w-full"
                    value={form?.phone}
                    id="phone"
                    onChange={(e) => setForm((prev) => ({ ...prev, phone: e.value }))}
                    disabled={loading}
                />
                <label htmlFor="phone">Phone</label>
            </FloatLabel>
            <FloatLabel className="mt-4">
                <InputNumber
                    useGrouping={false}
                    className="w-full"
                    value={form?.guardian_phone}
                    id="guardian_phone"
                    onChange={(e) => setForm((prev) => ({ ...prev, guardian_phone: e.value }))}
                    disabled={loading}
                />
                <label htmlFor="guardian_phone">Guardian Phone</label>
            </FloatLabel>

            <FloatLabel className="mt-4">
                <Dropdown
                    className="w-full"
                    value={branches?.find(({ id }) => id === form?.branch_id)}
                    inputId="user_branch"
                    options={branches}
                    optionLabel="title"
                    onChange={(e) => setForm((prev) => ({ ...prev, branch_id: e.value?.id }))}
                    disabled={loading}
                    pt={{
                        input: { className: TEXT_NORMAL },
                        item: { className: TEXT_NORMAL },
                    }}
                />
                <label htmlFor="user_branch">User Branch</label>
            </FloatLabel>

            <FloatLabel className="mt-4">
                <InputTextarea
                    value={form?.address || ""}
                    id="address"
                    rows={5}
                    cols={30}
                    className="w-full"
                    onChange={(e) => setForm((prev) => ({ ...prev, address: e.target.value }))}
                    disabled={loading}
                />
                <label htmlFor="address">Address</label>
            </FloatLabel>

            <Accordion className="mt-3">
                <AccordionTab header="History">
                    <FloatLabel className="mt-2">
                        <InputText
                            value={form?.history?.institute}
                            id="institute"
                            className="w-full"
                            onChange={(e) => setForm((prev) => ({ ...prev, history: { ...prev?.history, institute: e.target.value } }))}
                            disabled={loading}
                        />
                        <label htmlFor="institute">Last College</label>
                    </FloatLabel>
                    <FloatLabel className="mt-4">
                        <InputText
                            value={form?.history?.course}
                            id="history_course"
                            className="w-full"
                            onChange={(e) => setForm((prev) => ({ ...prev, history: { ...prev?.history, course: e.target.value } }))}
                            disabled={loading}
                        />
                        <label htmlFor="history_course">Last Class</label>
                    </FloatLabel>
                    <FloatLabel className="mt-4">
                        <InputText
                            value={form?.history?.refered_by}
                            id="refered_by"
                            className="w-full"
                            onChange={(e) => setForm((prev) => ({ ...prev, history: { ...prev?.history, refered_by: e.target.value } }))}
                            disabled={loading}
                        />
                        <label htmlFor="refered_by">Refered By</label>
                    </FloatLabel>
                </AccordionTab>
            </Accordion>

            <Divider />
            <TabHeader className="pt-1" title="Inquiry Details" highlights={["Course is not changeable after add"]} />

            <FloatLabel className="mt-5">
                <Dropdown
                    value={branches?.find((branch) => branch.id === form?.inquiry_branch_id)}
                    inputId="inquiry_branch"
                    options={branches}
                    optionLabel="title"
                    className="w-full"
                    onChange={(e) => setForm((prev) => ({ ...prev, inquiry_branch_id: e.value?.id }))}
                    disabled={loading}
                    pt={{
                        input: { className: TEXT_NORMAL },
                        item: { className: TEXT_NORMAL },
                    }}
                />
                <label htmlFor="inquiry_branch">Inquiry Branch</label>
            </FloatLabel>

            <FloatLabel className="mt-5">
                <Dropdown
                    value={courses?.find((course) => course.id === form?.course_id)}
                    inputId="course"
                    options={courses}
                    optionLabel="title"
                    className="w-full"
                    onChange={(e) => setForm((prev) => ({ ...prev, course_id: e.value?.id }))}
                    disabled={loading}
                    pt={{
                        input: { className: TEXT_NORMAL },
                        item: { className: TEXT_NORMAL },
                    }}
                />
                <label htmlFor="course">Course</label>
            </FloatLabel>

            <FloatLabel className="mt-5">
                <InputTextarea
                    value={form?.note}
                    id="note"
                    rows={5}
                    cols={30}
                    className="w-full"
                    onChange={(e) => setForm((prev) => ({ ...prev, note: e.target.value }))}
                    disabled={loading}
                    pt={{
                        root: { className: TEXT_NORMAL },
                    }}
                />
                <label htmlFor="note">Note</label>
            </FloatLabel>

            <HasRequiredAuthority requiredAuthority={AUTHORITIES.CREATE_INQUIRY}>
                <Button
                    className="mt-3"
                    label="Add Inquiry"
                    severity="warning"
                    loading={loading}
                    onClick={submit}
                    disabled={!form}
                    pt={{
                        label: { className: TEXT_NORMAL },
                        icon: { className: TEXT_NORMAL },
                    }}
                />
            </HasRequiredAuthority>
        </Dialog>
    );
}
